import React, { useState } from "react";
import Input from "../ui/Input";
import Button from "../ui/Button";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import CloseSubmitBtn from "../common-components/custom-comps/CloseSubmitBtn";
import { EditIcon1 } from "../../images/icons/icons";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";

const ManualExtensionModal = ({
  memberMobile,
  setMemberMobile,
  memberDetails,
  extendDays,
  setExtendDays,
  onGetDetails,
  onClose,
  onSave,
  isLoading,
  isSaveDisabled,
}) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleEditClick = () => {
    setIsEditing(!isEditing);
  };

  const tableColumns = [
    {
      dataField: "gymName",
      text: "Gym Name",
    },
    {
      dataField: "planName",
      text: "Plan Name",
    },
    {
      dataField: "startDate",
      text: "Start Date",
    },
    {
      dataField: "expireDate",
      text: "Expire Date",
    },
    {
      dataField: "subscriptionAdded",
      text: "Subscription Added",
    },
    {
      dataField: "extendDays",
      text: "Extend Days",
      formatter: (_, row) =>
        isEditing ? (
          <Input
            type="number"
            placeholder="Enter days"
            value={extendDays}
            onChange={(e) => setExtendDays(e.target.value)}
            style={{
              maxWidth: "100px",
              height: "38px",
              outline: "none",
              border: "1px solid #ced4da",
            }}
          />
        ) : (
          <span>{extendDays || "0"} days</span>
        ),
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <button
          onClick={handleEditClick}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "#6c757d",
            fontSize: "16px",
            height: "38px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          title="Edit days"
        >
          <EditIcon1 />
        </button>
      ),
    },
  ];

  // Table data
  const tableData = memberDetails
    ? [
        {
          gymName: memberDetails.gymName,
          planName: memberDetails.planName,
          startDate: memberDetails.startDate,
          expireDate: memberDetails.expireDate,
          subscriptionAdded: memberDetails.subscriptionAdded,
          extendDays: extendDays,
          action: "edit",
        },
      ]
    : [];

  return (
    <div className={`modal-body p-4 manual-extension-modal ${!memberDetails ? 'compact' : ''}`}>
      {/* Member Search Section */}
      <div className={`search-inputs-wrapper ${!memberDetails ? 'compact-layout' : ''}`}>
        <div className="input-wrapper">
          <Input
            type="text"
            placeholder="Enter mobile number"
            value={memberMobile}
            onChange={(e) => setMemberMobile(e.target.value)}
            className="search-input-field"
          />
        </div>
        <Button
          variant="primary"
          onClick={onGetDetails}
          disabled={isLoading}
          style={{
            backgroundColor: "#000000",
            borderColor: "#000000",
            color: "white",
            height:"50px"
          }}
        >
          {isLoading ? "Loading..." : "Get Details"}
        </Button>
      </div>

      {isLoading && (
        <div
          className={`loading-state ${!memberDetails ? 'text-center' : ''}`}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
            minHeight: "200px",
          }}
        >
          <ReactVortoxSpinner />
        </div>
      )}
      {/* Member Details Display */}
      {memberDetails && (
        <>
          {/* Basic Member Info */}
          <div className="row mb-4">
            <div className="col-md-6">
              <div className="mb-2">
                <strong>Member Name:</strong> {memberDetails.name}
              </div>
              <div className="mb-2">
                <strong>Member Mobile:</strong> {memberDetails.mobile}
              </div>
            </div>
          </div>

          {/* Subscription Details Table */}
          <div className="fullWidthFlexCenter overflowAuto separatedTable ">
            <PaymentLinkTable
              tableData={tableData}
              tableColumns={tableColumns}
              isFirstColSticky={false}
            />
          </div>

          {/* Additional Member Details */}
          <div className="row mt-3">
            <div className="col-md-6">
              <div className="mb-2">
                <strong>Plan Duration:</strong> {memberDetails.duration} days
              </div>
              <div className="mb-2">
                <strong>Plan Price:</strong> ₹{memberDetails.price}
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="mt-4">
            <CloseSubmitBtn
              closeLabel="Cancel"
              submitLabel="Save Extension"
              onClose={onClose}
              onSubmit={onSave}
              isSubmitDisabled={isSaveDisabled}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default ManualExtensionModal;
